export default {
      id: "directory-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#directory",
      toString: function () {
        return this.url;
      }
    }